import { useQuery } from '@tanstack/react-query';
import { getAutomationVerification } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

/** 오토DM 인증 상태 조회(studio). 화면 분기용 read-only. */
export const useAutomationVerification = (options?: { enabled?: boolean }) =>
    useQuery({
        queryKey: queryKeys.dmAutomation.verification(),
        queryFn: getAutomationVerification,
        enabled: options?.enabled ?? true,
        staleTime: 60 * 1000,
    });
